export default "__VITE_ASSET__BObfLL$F__"